import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ResponseCatalog, RequestParams } from 'Models'
import {
	CallModel,
	CallStatus,
	CreateCall,
	PotentialClientStatus,
	Status,
	UpdateCall,
} from 'Pages/coliseum'
import { Callback } from 'Src/types/utilTypes'

export type CallState = {
	call: ResponseCatalog<CallModel>
	callStatus: CallStatus[]
	status: Status[]
	requestParams: RequestParams
	potentialClientStatus: PotentialClientStatus[]
	formState: {
		open: boolean
		item?: CallModel
	}
}

export const CallInitialState: CallState = {
	call: new ResponseCatalog<CallModel>(),
	callStatus: [],
	status: [],
	potentialClientStatus: [],
	requestParams: new RequestParams(),
	formState: {
		open: false,
		item: undefined,
	},
}

export namespace CallNS {
	export type GetAll = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetAll = PayloadAction<ResponseCatalog<CallModel>>
	export type SetRequestParams = PayloadAction<{ params: RequestParams }>

	export type CreateOne = PayloadAction<CreateCall>
	export type UpdateOne = PayloadAction<{
		id: number
		data: UpdateCall
		callback?: Callback
	}>

	export type getAllCallStatus = PayloadAction
	export type setAllCallStatus = PayloadAction<CallStatus[]>

	export type getAllStatus = PayloadAction
	export type setAllStatus = PayloadAction<Status[]>

	export type getAllPotentialClientStatus = PayloadAction
	export type setAllPotentialClientStatus = PayloadAction<PotentialClientStatus[]>

	export type OpenForm = PayloadAction<{ item?: CallModel }>
	export type CloseForm = PayloadAction
}

export const callSlice = createSlice({
	name: 'call',
	initialState: CallInitialState,
	reducers: {
		getAll: (state, action: CallNS.GetAll) => {},
		setAll: (state, action: CallNS.SetAll) => {
			state.call = action.payload
		},
		setRequestParams: (state, action: CallNS.SetRequestParams) => {
			state.requestParams = action.payload.params
		},
		clearAll: (state) => {
			state.call = new ResponseCatalog<CallModel>()
			state.requestParams = new RequestParams()
		},

		updateOne: (state, action: CallNS.UpdateOne) => {},
		createOne: (state, action: CallNS.CreateOne) => {},
		getAllCallStatus: (state, action: CallNS.getAllCallStatus) => {},
		setAllCallStatus: (state, action: CallNS.setAllCallStatus) => {
			state.callStatus = action.payload
		},

		getAllStatus: (state, action: CallNS.getAllStatus) => {},
		setAllStatus: (state, action: CallNS.setAllStatus) => {
			state.status = action.payload
		},
		getAllPotentialClientStatus: (state, action: CallNS.getAllPotentialClientStatus) => {},
		setAllPotentialClientStatus: (state, action: CallNS.setAllPotentialClientStatus) => {
			state.potentialClientStatus = action.payload
		},
		openForm: (state, action: CallNS.OpenForm) => {
			state.formState = {
				open: true,
				item: action.payload.item,
			}
		},
		closeForm: (state, action: CallNS.CloseForm) => {
			state.formState = CallInitialState.formState
		},
	},
})
